module.exports = __webpack_public_path__ + "public/Icons/gotoSite.svg?397a0367";